<template>
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
    <!-- Generator: Adobe Illustrator 29.7.1, SVG Export Plug-In . SVG Version: 2.1.1 Build 8)  -->
    <defs>
    </defs>
    <g>
      <path class="st0" d="M29.56,9.9v80.2c-4.18-2.13-7.98-4.9-11.28-8.18-2.23-2.22-4.23-4.66-5.96-7.3-4.63-7.07-7.32-15.53-7.32-24.62s2.69-17.54,7.32-24.62c1.73-2.64,3.73-5.09,5.96-7.3,3.3-3.28,7.1-6.05,11.28-8.18Z"/>
      <path class="st2" d="M95,50c0,5.26-.9,10.31-2.56,15-1.21,3.41-2.81,6.64-4.76,9.62-8.04,12.27-21.91,20.38-37.68,20.38-7.36,0-14.31-1.77-20.44-4.9V9.9c6.13-3.13,13.08-4.9,20.44-4.9,15.77,0,29.64,8.11,37.68,20.38,1.95,2.98,3.56,6.2,4.76,9.62,1.66,4.69,2.56,9.74,2.56,15Z"/>
      <g>
        <path class="st0" d="M53.55,32.13c-1.91.91-3.7,2.15-5.27,3.73-7.45,7.45-7.45,19.53,0,26.98,7.45,7.45,19.53,7.45,26.98,0,1.58-1.58,2.82-3.37,3.73-5.27-7.05,6.68-18.19,6.57-25.1-.34-6.91-6.91-7.03-18.05-.34-25.1Z"/>
        <polygon class="st0" points="73.05 36.11 69.97 33.1 70.58 37.36 66.77 39.37 71.02 40.1 71.75 44.35 73.76 40.54 78.02 41.15 75.01 38.07 76.92 34.2 73.05 36.11"/>
      </g>
    </g>
    <path class="st1" d="M50,5C25.1,5,5,25.1,5,50s20.1,45,45,45,45-20.1,45-45S74.9,5,50,5ZM50,93c-23.7,0-43-19.3-43-43S26.3,7,50,7s43,19.3,43,43-19.3,43-43,43Z"/>
  </svg>
</template>

<script>
  export default {
    name: "PkrIcon"
  }
</script>

<style scoped>
  .st0 {
    fill: #f6f6f6;
  }

  .st1 {
    fill: #3a3a3a;
  }

  .st2 {
    fill: #014510;
  }
</style>
